import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import logoImg from '../assets/blast-logo.webp';

export default function Layout({ children }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const memberInfo = JSON.parse(localStorage.getItem('blast_member_info') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('blast_member_token');
    localStorage.removeItem('blast_member_info');
    document.cookie = 'blast_logged_in_name=; domain=.ridewithblast.com; path=/; max-age=0';
    document.cookie = 'blast_member_token=; domain=.ridewithblast.com; path=/; max-age=0';
    window.location.href = '/login';
  };

  const linkStyle = ({ isActive }) => ({
    display: 'block',
    padding: '10px 16px',
    borderRadius: 6,
    color: isActive ? '#F0EDE4' : '#8B92A0',
    background: isActive ? 'rgba(208,33,39,0.12)' : 'transparent',
    borderLeft: isActive ? '3px solid #D02127' : '3px solid transparent',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: isActive ? 700 : 500,
    marginBottom: 4,
  });

  return (
    <div style={{ minHeight: '100vh', background: '#12151A', color: '#F0EDE4', fontFamily: "'Segoe UI', sans-serif" }}>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '14px 20px', borderBottom: '1px solid #262b33', background: '#1C2128',
        position: 'sticky', top: 0, zIndex: 20,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <button
            onClick={() => setMenuOpen(true)}
            style={{ background: 'transparent', border: '1px solid #262b33', borderRadius: 6, padding: '8px 12px', color: '#F0EDE4', fontSize: 18, cursor: 'pointer' }}
          >
            ☰
          </button>
          <img src={logoImg} alt="Blast Motor Club" style={{ height: 28, width: 'auto' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <a href="https://ridewithblast.com" style={{ color: '#2B6996', fontSize: 12, textDecoration: 'none', fontWeight: 700 }}>
            ← Beranda
          </a>
          <button
            onClick={handleLogout}
            style={{ background: 'transparent', border: '1px solid #262b33', color: '#8B92A0', padding: '6px 12px', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}
          >
            Logout
          </button>
        </div>
      </div>

      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 30 }}
        />
      )}

      <aside style={{
        position: 'fixed', top: 0, left: 0, height: '100vh', width: 240,
        background: '#1C2128', borderRight: '1px solid #262b33', padding: '20px 12px',
        display: 'flex', flexDirection: 'column', zIndex: 40,
        transform: menuOpen ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform 0.25s ease',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <img src={logoImg} alt="Blast Motor Club" style={{ height: 32, width: 'auto' }} />
          <button
            onClick={() => setMenuOpen(false)}
            style={{ background: 'transparent', border: 'none', color: '#8B92A0', fontSize: 20, cursor: 'pointer' }}
          >
            ✕
          </button>
        </div>
        <nav style={{ flex: 1 }} onClick={() => setMenuOpen(false)}>
          <NavLink to="/dashboard" style={linkStyle}>Dashboard</NavLink>
          <NavLink to="/profile" style={linkStyle}>Edit Profil</NavLink>
          <NavLink to="/live-touring" style={linkStyle}>Live Touring</NavLink>
          <NavLink to="/history" style={linkStyle}>History Touring</NavLink>
        </nav>
        <div style={{ borderTop: '1px solid #262b33', paddingTop: 16, marginTop: 16 }}>
          <p style={{ fontSize: 12, color: '#8B92A0', marginBottom: 10, paddingLeft: 8 }}>{memberInfo.name || 'Member'}</p>
          <button
            onClick={handleLogout}
            style={{ width: '100%', background: 'transparent', border: '1px solid #262b33', color: '#8B92A0', padding: '8px 0', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}
          >
            Logout
          </button>
        </div>
      </aside>

      <main style={{ padding: '24px 20px', overflowX: 'auto' }}>
        {children}
      </main>
    </div>
  );
}
